<template>
  <div class="component--charging_rate_details">
    <div class="inner-wrap">
      <!-- <div v-if="data.type=='Time'"> -->
        <List :action="action" :path="'charging_rate_detail'" :defaultFilter="{chargingRateId:id}" :defaultData="{chargingRateId:id}"></List>
      <!-- </div> -->
      
    </div>
  </div>
</template>

<script>
import List from "@/views/custom/List";
export default {
  props: ["data","k","field","action"],
  components: {List},
  created() {
  },
  async beforeMount(){
    this.id = this.$route.params.id;
  },
  methods: {
    addItem(){
      var obj = {
        startTime:"",
        endTime:"",
        fee:"",
        peak:"",
        point:"",
        weekday:"",
        penaltyUnit:"",
        unit:"",
        penaltyFee:"",
      };
      this.items.push(obj);
    },
    deleteItem(index){
      this.items.splice(index, 1);
      this.saveData();
    },
    saveData(){
      this.$emit("input", this.items);
    }
  },
  data() {
    return {
      id:0,
      items: []
    }
  }

}
</script>

<style lang="scss" scoped>
.component--charging_rate_details{
  flex-grow: 1;
  overflow-x: auto;
  .inner-wrap{
    table{
      width: 100%;
      tbody {
        input{
          width: 80px;
        }
      }
    }
  }
  .align-right{
    text-align: right;
  }

}
</style>